var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"container-fluid has-action-bar",attrs:{"id":"OurCertificates"}},[_c('div',{staticClass:"container-md min-height-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('silent-box',{staticClass:"p-5",attrs:{"gallery":_vm.gallery}})],1)])])]),_c('footer-pages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }